<div class="main-container">
  <div class="nav">
    <app-side-nav-bar *ngIf="languageService.available"></app-side-nav-bar>
  </div>
  <div class="row" id="main-page">
    <div class="header">
      <app-header></app-header>
    </div>
    <div class="contents">
      <router-outlet *ngIf="languageService.available"></router-outlet>
      <app-comments id="fb-comments" [class.show-comments]="commentsVisible"></app-comments>
    </div>
  </div>
</div>
